angular.module('city', ['ui.router','confirm.modal.html', 'ngResource', 'ngTable', 'ui.bootstrap']);

angular.module('city').config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {

    $stateProvider
    .state('city', {
        url         : "/city",
        templateUrl : server+"/views/m/city",
        controller  : 'city.list',
        resolve     : {
            loginRequired: loginRequired
        },
        ncyBreadcrumb: {
            parent: 'home',
            label: 'City'
        }
    })

    .state('city_create', {
        url         : "/city/create",
        templateUrl : server+"/views/m/city/create",
        controller  : 'city.create',
        resolve     : {
            loginRequired: loginRequired
        },
        ncyBreadcrumb: {
            parent: 'city',
            label: 'Adicionar'
        }
    })

    .state('city_show', {
        url         : "/city/:id",
        templateUrl : server+"/views/m/city/show",
        controller  : 'city.show',
        resolve     : {
            loginRequired: loginRequired
        },
        ncyBreadcrumb: {
            parent: 'city',
            label: '{{city.id}}'
        }
    })

}]);

/**
 * List Controller
 */
angular.module('city').
controller('city.list', ['$scope', '$http', '$auth', '$q', 'NgTableParams', '$city', function($scope, $http, $auth, $q, NgTableParams, $city) {
    $scope.tableParams = new NgTableParams({
        page: 1,
        count: 10
    }, {
        counts: [],
        filterDelay: 0,
        getData: function(params) {
            return $city.query(params.url()).$promise.then(function(data) {
                params.total(data.total);
                return data.data;
            });
        }
    });
}]);

/**
 * Create Controller
 */
angular.module('city').
controller('city.create', ['$scope', '$state', '$city', function($scope, $state, $city) {
    $scope.save = function() {
        $city.save($scope.city).$promise.then(function(data) {
            $state.go('city_show', {
                id: data.id
            });
        });
    }
}]);

/**
 * Show, Edit, Delete Controller
 */
angular.module('city').
controller('city.show', ['$state', '$scope', '$stateParams', '$uibModal', '$city', function($state, $scope, $stateParams, $uibModal, $city) {

    $scope.editing = false;

    $scope.toggleEdit = function() {
        $scope.editing = !$scope.editing;
    }

    $city.get({
        id: $stateParams.id
    }).$promise.then(function(data) {
        $scope.city = data;
    }, function(error) {
        if (error.status == 404) {
            $state.go('notFound');
        }
    });

    $scope.confirmUpdate = function() {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'confirm.modal.html',
            size: 'sm',
            scope: $scope,
            controller: ['$scope', '$uibModalInstance', '$city', function($scope, $uibModalInstance, $city) {

                $scope.title = 'Deseja atualizar?';
                $scope.cancel_text = 'Cancelar';
                $scope.success_text = 'Concluído';

                var city = $scope.$parent.city;

                $scope.confirm = function() {
                    $city.update({
                        id: city.id
                    }, city).$promise.then(function(data) {
                        $uibModalInstance.dismiss('cancel');
                        $scope.$parent.toggleEdit();
                    })
                }

                $scope.cancel = function() {
                    $uibModalInstance.dismiss('cancel');
                };

            }]
        });
    };

    $scope.confirmDelete = function() {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'confirm.modal.html',
            size: 'sm',
            scope: $scope,
            controller: ['$state', '$scope', '$uibModalInstance', '$city', function($state, $scope, $uibModalInstance, $city) {

                $scope.title = 'Deseja remover esse registro?';
                $scope.cancel_text = 'Não';
                $scope.success_text = 'Sim';

                var city = $scope.$parent.city;

                $scope.confirm = function() {
                    $city.delete({id:city.id}).$promise.then(function(data){
                        $uibModalInstance.dismiss('cancel');
                        $state.go('city');
                    })
                }

                $scope.cancel = function() {
                    $uibModalInstance.dismiss('cancel');
                };

            }]
        });
    };

}]);


/**
 * Factory
 */
angular.module('city').
factory("$city", function($resource) {
    var resource = $resource(api + 'city/:id', null, {
        'query': {
            method: 'GET',
            isArray: false
        },
        'update': {
            method: 'PUT'
        }
    });
    return resource;
});
